import log, { type Event } from '@atlassian/jira-common-util-logging/src/log.tsx';
import FetchError, { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';

/**
 * Wrapper over log.safeErrorWithoutCustomerData that converts FetchError's originalResponse to a string
 */
export const logSafeErrorWithoutCustomerDataWrapper = async (
	location: string,
	message: string,
	event?: Event,
): Promise<Event | undefined> => {
	let modifiedEvent = event;

	// Definies consumable shape for logging for ValidationError
	if (modifiedEvent instanceof ValidationError) {
		modifiedEvent = {
			message: modifiedEvent.message,
			statusCode: modifiedEvent.statusCode,
			traceId: modifiedEvent.traceId,
			errors: JSON.stringify(modifiedEvent.errors),
			originalResponse: JSON.stringify(modifiedEvent.originalResponse),
		};
	}

	if (
		modifiedEvent instanceof FetchError &&
		modifiedEvent.originalResponse &&
		// We can't guarantee that response object is always in unread state when we try to log it
		!modifiedEvent.originalResponse?.bodyUsed
	) {
		const originalResponseText = await modifiedEvent.originalResponse.text();
		modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
		delete modifiedEvent.originalResponse;
	}

	log.safeErrorWithoutCustomerData(location, message, modifiedEvent);

	// Returning the modified error so the original response text can be used in the error handler
	return modifiedEvent;
};
